import React, { useEffect, useState, useRef } from 'react';

import VideoPlayer from '../../../components/VideoPlayer';
import ImageSlider from '../../../components/ImageSlider';
import {
  insertContentsTimeLog,
  insertItemLog,
  insertMakeShopItemLog,
  insertSlideLog,
} from '../../../modules/NetworkFunction';
import ProductSlider from '../../../components/ProductSlider';

function ContentsPreviewH({
  videoUrl,
  slideList,
  btnColor,
  fontColor,
  font,
  btnBorderRadius,
  contentNo,
  detailPath,
  shopMode,
  margin,
  contentType,
}) {
  const [currentSlideIdx, setCurrentSlideIdx] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const [playing, setPlaying] = useState(false);
  const [imageSlider, setImageSlider] = useState();
  const [productSlider, setProductSlider] = useState();

  const timerId = useRef();
  const playerRef = useRef();
  const sliderRef = useRef();
  const buyBtnRef = useRef();

  useEffect(() => {
    timerId.current = setInterval(async () => {
      if (playing) {
        const time = await playerRef.current.getCurrentTime();
        setCurrentTime(Number.parseInt(time));

        if (time !== null && contentNo) {
          const params = `?contentsNo=${contentNo}&time=${time}`;
          insertContentsTimeLog(params);
        }
      }
    }, 1000);

    return () => {
      clearInterval(timerId.current);
    };
  }, [playerRef, playing, timerId, contentNo]);

  useEffect(() => {
    const checkPlayer = () => {
      const time = currentTime;

      for (let i = 0; i < slideList.length; i++) {
        if (slideList[i].displayTime > time) {
          let index = i < 1 ? 0 : i - 1;
          setCurrentSlideIdx(index);
          break;
        } else if (i === slideList.length - 1) {
          setCurrentSlideIdx(i);
        }
      }
    };
    checkPlayer();
  }, [currentTime, slideList]);

  useEffect(() => {
    if (buyBtnRef.current) {
      buyBtnRef.current.style.setProperty('font-family', font, 'important');
    }
  }, [font]);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.handleChangeSlideIdx(currentSlideIdx);
    }
  }, [currentSlideIdx]);

  const itemClick = (idx) => {
    _setPage(slideList[idx], idx);
  };

  const _setPage = (slideItem, index) => {
    if (index !== currentSlideIdx) {
      playerRef.current.seekTo(slideItem.displayTime);
      setCurrentSlideIdx(index);
      setPlaying(true);

      if (contentNo) {
        insertSlideLog(`?slideNo=${slideItem.slideNo}`);
      }
    }
  };

  const handleBuyBtnClick = () => {
    console.log('contentspreview h buyBtn Click');
    console.log('currentSlideIdx', currentSlideIdx);
    console.log('slideList', slideList);
    console.log('slideList[currentSlideIdx]', slideList[currentSlideIdx]);
    console.log(
      'slideList[currentSlideIdx].productNo',
      slideList[currentSlideIdx].productNo
    );
    console.log('detailPath', detailPath);

    if (detailPath) {
      // window.open(
      //   detailPath + `?product_no=${slideList[currentSlideIdx].productNo}`,
      //   '_blank'
      // );
      window.open(detailPath + slideList[currentSlideIdx].productNo, '_blank');
      if (shopMode === 'cafe24') {
        insertItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      } else {
        insertMakeShopItemLog(
          `?slideNo=${slideList[currentSlideIdx].slideNo}&itemNo=${slideList[currentSlideIdx].itemNo}`
        );
      }
    }
  };

  // popup일 경우 체크
  const IsPopup = (style) => {
    return style.includes('popup') || style.includes('팝업');
  }

  return (
    <div
      style={{
        position: IsPopup(contentType) ? 'absolute' : 'relative',
        width: '90%',
        height: '480px',
        margin: IsPopup(contentType) ? '0 auto' : `${margin}px auto`,
        top: IsPopup(contentType) ? '50%' : 'unset',
        left: IsPopup(contentType) ? '50%' : 'unset',
        transform: IsPopup(contentType)
          ? 'translate(-50%, -50%)'
          : 'none',
        boxShadow: '0px 0px 11.6991px rgba(0, 0, 0, 0.25)',
        borderRadius: '12.5px',
        backgroundColor: '#ffffff',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderRadius: 12.5,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '75%',
          }}
        >
          <div
            className="video-wrapper-horizontal"
            style={{ width: '50%', height: '100%', position: 'relative' }}
          >
            {/*<p>영상</p>*/}

            <VideoPlayer
              ref={playerRef}
              videoUrl={videoUrl}
              playing={playing}
              setPlaying={setPlaying}
              isMobile={false}
            />

            <div style={{ position: 'absolute', bottom: -6, left: -1 }}>
              <img
                src="https://wizmon-bucket.s3.ap-northeast-2.amazonaws.com/icons/ic-rect.png"
                alt="영상 속 다른 상품"
              />
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '45%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: 20,
                  fontWeight: 700,
                  whiteSpace: 'nowrap',
                  fontFamily: font,
                }}
              >
                영상 속 다른 상품
              </div>
            </div>
          </div>

          <div
            className="slide-wrapper"
            style={{
              width: '50%',
              height: '100%',
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              backgroundColor: '#EBEBEB',
              borderTopRightRadius: 12.5,
            }}
          >
            {slideList.length > 0 && (
              <ImageSlider
                slideList={slideList}
                ref={sliderRef}
                handleSlideClick={(idx) => {
                  _setPage(slideList[idx], idx);
                }}
                setSlider={setImageSlider}
                syncSlider={productSlider}
              />
            )}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            height: '25%',
          }}
        >
          <ProductSlider
            slideList={slideList}
            currentSlideIdx={currentSlideIdx}
            itemClick={itemClick}
            btnColor={btnColor}
            fontColor={fontColor}
            font={font}
            setSlider={setProductSlider}
            syncSlider={imageSlider}
            isHorizontal={true}
          />

          <div
            style={{
              width: '50%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <button
              ref={buyBtnRef}
              style={{
                width: '95%',
                height: '60%',
                borderRadius: btnBorderRadius,
                borderWidth: 0,
                backgroundColor: btnColor ?? '#000',
                // color: fontColor,
                color: '#fff',
                fontWeight: 'bold',
                fontSize: 23,
              }}
              onClick={handleBuyBtnClick}
            >
              구매하기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ContentsPreviewH;
